import { OnShelfAvailabilityStatistics } from "../../../models/Statistics";

export const REQUEST_ONSHELFAVAILABILITY = "REQUEST_ONSHELFAVAILABILITY";
export const REQUEST_ONSHELFAVAILABILITY_DONE =
  "REQUEST_ONSHELFAVAILABILITY_DONE";

export interface FetchOnShelfAvailability {
  type: typeof REQUEST_ONSHELFAVAILABILITY;
  payload: ReadonlyArray<OnShelfAvailabilityStatistics>;
}

export interface FetchOnShelfAvailabilityDone {
  type: typeof REQUEST_ONSHELFAVAILABILITY_DONE;
  payload: ReadonlyArray<OnShelfAvailabilityStatistics>;
}

export interface OnShelfAvailabilityState {
  isLoading: boolean;
  onShelfAvailabilityStatistics: ReadonlyArray<OnShelfAvailabilityStatistics>;
}

export type OnShelfAvailabilityActions =
  | FetchOnShelfAvailability
  | FetchOnShelfAvailabilityDone;
